import { VStack, Heading, Image, Text, Box } from '@chakra-ui/react';
import { IBook } from '@partiu/api/types';
import { PiHeartFill } from 'react-icons/pi';
import { SlEarphones } from 'react-icons/sl';
import { useOpenBook } from '../../contexts/BookContext';
import { badges } from '../../pages/Profile/components/Plans';
import { FaRegStar } from 'react-icons/fa';

interface BookProps {
  book: IBook;
  receivedBook?: boolean;
}

export function Book({ book, receivedBook }: BookProps) {
  const { openBook } = useOpenBook();

  return (
    <VStack
      position={'relative'}
      spacing={0}
      cursor={'pointer'}
      onClick={() => openBook(book, receivedBook)}
      align={'flex-start'}
      width={'100%'}
    >
      {book.type === 'audiobook' && (
        <VStack position={'absolute'} top="5px" left="5px">
          <SlEarphones size={25} color={'white'} filter="drop-shadow(0px 0px 3px rgba(0,0,0,1))" />
        </VStack>
      )}
      {book.isBestSeller && (
        <Box
          display={'flex'}
          position={'absolute'}
          top={2}
          left={2}
          flexDirection={'row'}
          alignItems={'center'}
          gap={1}
          padding="3px"
          borderRadius="6px"
          backgroundColor={'#000000B3'}
        >
          <FaRegStar color="white" size={15} />
          <Text fontSize={12} color="white">
            Best Seller
          </Text>
        </Box>
      )}
      <VStack position={'absolute'} top="5px" right="5px">
        {badges.map(
          (badge) =>
            book.levels.includes(badge.id) && (
              <Image
                key={badge.id}
                filter="drop-shadow(0px 0px 3px rgba(0,0,0,1))"
                src={`/${badge?.image}`}
                height={'24px'}
              />
            )
        )}
      </VStack>
      {book.isFavorite && (
        <VStack position={'absolute'} top="5px" right="30px">
          <PiHeartFill fontSize={'20px'} color="red" />
        </VStack>
      )}
      <Image
        boxShadow={'rgba(100, 100, 111, 0.2) 0px 5px 8px 0px'}
        borderRadius={'5px'}
        aspectRatio={0.7}
        border={'1px solid #ededed'}
        width={'100%'}
        objectFit={'cover'}
        src={book.cover}
      />
      <Heading
        paddingTop="8px"
        width={'100%'}
        whiteSpace={'nowrap'}
        overflowX={'clip'}
        textOverflow={'ellipsis'}
        fontSize={'12px'}
      >
        {book.title}
      </Heading>
      <Text 
        color="#787878" 
        fontSize={'12px'}
        width={'100%'}
        whiteSpace={'nowrap'}
        overflowX={'clip'}
        textOverflow={'ellipsis'}
      >
        {book.author}
      </Text>
    </VStack>
  );
}
